import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Plus, Clock, CreditCard, GraduationCap } from 'lucide-react';

const EXAM_STATUS = {
  scheduled: { label: 'Scheduled', color: 'bg-blue-100 text-blue-800' },
  ongoing: { label: 'Ongoing', color: 'bg-amber-100 text-amber-800' },
  completed: { label: 'Completed', color: 'bg-green-100 text-green-800' },
  result_published: { label: 'Result Published', color: 'bg-purple-100 text-purple-800' }
};

const ExamListTab = ({ 
  exams, 
  onCreateExam, 
  onViewSchedule, 
  onViewAdmitCards 
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold">All Exams</h2>
        <Button onClick={onCreateExam} data-testid="create-exam-btn">
          <Plus className="h-4 w-4 mr-2" /> Create Exam
        </Button>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {exams.map(exam => (
          <Card key={exam.id} className="hover:shadow-lg transition-shadow" data-testid={`exam-${exam.id}`}>
            <CardHeader>
              <div className="flex justify-between items-start">
                <div>
                  <CardTitle className="text-lg">{exam.name}</CardTitle>
                  <CardDescription>{exam.exam_type?.replace('_', ' ').toUpperCase()} • {exam.term}</CardDescription>
                </div>
                <Badge className={EXAM_STATUS[exam.status]?.color || 'bg-gray-100'}>
                  {EXAM_STATUS[exam.status]?.label || exam.status}
                </Badge>
              </div>
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="text-sm space-y-1">
                <p><span className="text-muted-foreground">Date:</span> {exam.start_date} to {exam.end_date}</p>
                <p><span className="text-muted-foreground">Classes:</span> {exam.classes?.length || 0} classes</p>
              </div>
              <div className="flex gap-2 flex-wrap">
                <Button size="sm" variant="outline" onClick={() => onViewSchedule(exam)}>
                  <Clock className="h-3 w-3 mr-1" /> Schedule
                </Button>
                <Button size="sm" variant="outline" onClick={() => onViewAdmitCards(exam)}>
                  <CreditCard className="h-3 w-3 mr-1" /> Admit Cards
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
        {exams.length === 0 && (
          <Card className="col-span-full p-8 text-center text-muted-foreground">
            <GraduationCap className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p>No exams created yet. Click Create Exam to get started.</p>
          </Card>
        )}
      </div>
    </div>
  );
};

export default ExamListTab;
